
import { useState, useEffect } from 'react';
import { abEngine, ABGroup } from '../lib/abTest';

export const useABTest = () => {
  const [group, setGroup] = useState<ABGroup>('A'); // 기본값 A

  useEffect(() => {
    const assignedGroup = abEngine.getOrAssignGroup();
    setGroup(assignedGroup);
  }, []);

  return {
    group,
    isA: group === 'A',
    isB: group === 'B'
  };
};
